// extracted by mini-css-extract-plugin
export default {"MuiDataGrid-columnHeaders":"Popup_MuiDataGrid-columnHeaders__gAcj6","popup-image":"Popup_popup-image__sU9cO"};